var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueFeedback,{attrs:{"type":"error"},scopedSlots:_vm._u([{key:"feedback-title",fn:function(){return [_vm._v("Hoppá!")]},proxy:true},{key:"feedback-content",fn:function(){return [_c('p',{staticClass:"sf-text"},[_vm._v("Technikai hiba történt!")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }